<template>
  <div>
    <b-button @click="downloadFile">Excel</b-button>
  </div>

</template>

<script>
  // *****************************************************************************************************************
  //                                                  IMPORTS
  // *****************************************************************************************************************
  // import { } from '../../expertoRetail/defaultPayloads/organismStockBreak'
  import { general } from '../../../services/api/ExpertoRetail'
  import { DimensionUtils, GeneralUtils } from '@/mixins/index'
  // import { DimensionUtils, GeneralUtils } from '@/mixins/index'
  export default {
    name: '',
    // *****************************************************************************************************************
    //                                                 MIXINS
    // *****************************************************************************************************************
    mixins: [GeneralUtils, DimensionUtils],
    // *****************************************************************************************************************
    //                                                  PROPS
    // *****************************************************************************************************************
    props: ['parameters'],
    // *****************************************************************************************************************
    //                                                  COMPONENTS
    // *****************************************************************************************************************
    components: {},
    data () {
      return {}
    },
    // *****************************************************************************************************************
    //                                                HOOKS
    // *****************************************************************************************************************
    created () {
    },
    watch: {},
    computed: {
      propParameters () {
        return this.parameters
      }
    },
    // *****************************************************************************************************************
    //                                                METHODS
    // *****************************************************************************************************************
    methods: {
      // ********************************************** VUEX COMMITS ***************************************************
      // ********************************************** REQUESTS *******************************************************
      downloadFile () {
        let parameters = this.propParameters
        this.loading = true
        return new Promise((resolve, reject) => {
          let vm = this
          general.downloadGridToXlsx(parameters)
            .then(response => {
              resolve()
            })
            .catch(error => {
              reject(error)
            })
            .finally(() => {
              vm.loading = false
            })
        })
      }
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/expertoRetail/components/ExcelDownload/ServerDataToExcel.vue